import { Injectable } from '@angular/core';
import { AjustesProvider } from '../ajustes/ajustes';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})

export class CryptoProvider {
    constructor(
        private ajustesProvider: AjustesProvider,
    ){}
    public decryptData(encryptedText: string) {
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Define the key and IV
        const keyBytes = CryptoJS.enc.Utf8.parse(this.ajustesProvider.ajustes.realm); // Ensure this matches the key used in C#
        const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes of zeros

        // Decrypt the data
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedBytes },
            keyBytes,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convert the decrypted data to a UTF-8 string
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
